<template>
  <div>
    <div v-if="(getEventStart(event) && !getEventEnd(event))"
         :style="{ backgroundColor: event.color, left: calculateStartPositionDisk(event.startEvent, period) + 'px', position: 'absolute',  }"
         class="disk range-date-disk"
         style="width: 34px"
         @mouseenter="showTooltip(event.id, $event, event.startEvent, event.endEvent, event, false)"
         @mouseleave="hideTooltip()">
      <div v-if="event.id === hoveredEventId" :style="tooltipStyle"
           class="tooltip-custom">
        <div class="tooltip-title" :style="{ 'color': getContrastColor(event.color)}">
          {{
            (event.event_type && !event.event_type.hasOwnProperty('text') ? $t(getI18nEvenement(event.event_type)) : $t(event.event_type.text)) + (event.bilanType ? ` (${event.bilanType})` : '')
          }}
        </div>
        <div class="tooltip-date">{{ format(event.startEvent, 'dd-MM-yyyy') }}</div>
      </div>
      <div class="inner-disk"></div>
    </div>

    <div v-else-if="getEventStart(event) && getEventEnd(event)"
         :style="{ backgroundColor: event.color, width: calculateDuration(event.startEvent, event.endEvent) + 'px', left: calculateStartPositionRange(event.startEvent, period) + '%', position: 'absolute', zIndex:'1', borderRadius:'2px', border:'1px solid grey', top: '0', bottom: '0', height: '35px' }"
         class="disk" @mouseenter="showTooltip(event.id, $event, event.startEvent, event.endEvent, event, false)"
         @mouseleave="hideTooltip()"
         @mousemove="updateTooltipPosition($event, event.startEvent, event.endEvent)">
      <div v-if="event.id === hoveredEventId" :style="tooltipStyle"
           class="tooltip-custom">
        <div v-if="event.hasOwnProperty('name')" :style="{ 'color': getContrastColor(event.color)}">
          {{
            event.name
          }}
        </div>
        <div v-else-if="event.event_type" :style="{ 'color': getContrastColor(event.color)}" class="tooltip-title">
          {{
            (event.event_type && !event.event_type.hasOwnProperty('text') ? $t(getI18nEvenement(event.event_type)) : $t(event.event_type.text)) + (event.bilanType ? ` (${event.bilanType})` : '')
          }}
        </div>
        <div :style="{ 'color': getContrastColor(event.color)}" class="tooltip-date">{{
            format(event.startEvent, 'dd-MM-yyyy') + ' - ' + format(event.endEvent, 'dd-MM-yyyy')
          }}
        </div>
      </div>
    </div>

    <template v-if="event.hasOwnProperty('nestedEvents') && event.nestedEvents && event.nestedEvents.length > 0">
      <div v-for="nestedEvent in getNestedEventsForPeriod(period)" :key="nestedEvent.id"
           :style="{ backgroundColor: '#9E0430', left: calculateNestedAbsolutePosition(nestedEvent) + 'px', position: 'absolute' }"
           class="disk nested-date-disk"
           @mouseenter="showTooltip(nestedEvent.id, $event, nestedEvent.startEvent, event.endEvent, nestedEvent, true)"
           @mouseleave="hideTooltip()"
           @mousemove="updateTooltipPosition($event, nestedEvent.startEvent, nestedEvent.endEvent)">
        <div v-if="nestedEvent.id === hoveredEventId" :style="tooltipStyle"
             class="tooltip-custom-nested">
          <div class="tooltip-title" :style="{ 'color': getContrastColor(event.color)}">
            {{
              (nestedEvent.event_type && !nestedEvent.event_type.hasOwnProperty('text') ? $t(getI18nEvenement(nestedEvent.event_type)) : $t(nestedEvent.event_type.text)) + (nestedEvent.bilanType ? ` (${nestedEvent.bilanType})` : '')
            }}
          </div>
          <div class="tooltip-date">{{ format(nestedEvent.startEvent, 'dd-MM-yyyy') }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  addMonths,
  addWeeks,
  differenceInDays, differenceInMinutes,
  endOfMonth,
  endOfWeek,
  format,
  getDaysInMonth,
  isSameDay,
  isSameMonth,
  isSameWeek, startOfDay,
  startOfMonth,
  startOfWeek,
  differenceInMonths
} from 'date-fns';
import {fr} from 'date-fns/locale';

export default {
  name: "Evenement",
  props: {
    event: {
      type: Object,
      default: {}
    },
    period: {
      type: Date,
    },
    evenementType: {
      type: Array,
      default: []
    },
    textColor: {
      type: String,
      default: 'white'
    },
    scale: {
      type: String,
      default: 'month'
    },
    isNested: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hoveredEventId: null,
      tooltipStyle: {
        position: 'absolute',
        left: '50%',
        bottom: '140%',
        '--color-event': '#000'
      }
    }
  },

  computed: {
    baseWidth() {
      if (this.scale === 'month') {
        return 60;
      } else if (this.scale === 'week') {
        return 100;
      } else if (this.scale === 'day') {
        return 40
      }
      return 60;
    }
  },


  methods: {
    getI18nEvenement(value) {
      let evenement = this.evenementType.find((s) => {
        return s.value === value;
      });
      return evenement ? evenement.text : null;
    },
    format(date, formatStr) {
      return format(date, formatStr, {locale: fr});
    },
    getEventStart(event) {
      return new Date(event.startEvent);
    },
    getEventEnd(event) {
      return event.endEvent ? new Date(event.endEvent) : null;
    },

    getNestedEventsForPeriod(period) {
      if (!this.event.nestedEvents || this.event.nestedEvents.length === 0) {
        return [];
      }

      return this.event.nestedEvents.filter(nestedEvent => {
        const nestedDate = new Date(nestedEvent.startEvent);
        return isSameMonth(nestedDate, period);
      });
    },

    calculateNestedAbsolutePosition(nestedEvent) {
      const nestedDate = new Date(nestedEvent.startEvent);
      const dayOfMonth = nestedDate.getDate();
      const daysInMonth = getDaysInMonth(this.period);

      if (this.scale === 'month') {
        const positionInMonthPx = (dayOfMonth / daysInMonth) * this.baseWidth;
        return positionInMonthPx - 6.5;
      } else if (this.scale === 'week') {
        const startOfCurrentWeek = startOfWeek(this.period, {weekStartsOn: 1});
        const daysFromWeekStart = differenceInDays(nestedDate, startOfCurrentWeek);
        const positionInWeekPx = (daysFromWeekStart / 7) * this.baseWidth;
        return positionInWeekPx + 6.5;
      } else if (this.scale === 'day') {
        return 6.5;
      }
      return 0;
    },

    calculateStartPositionDisk(eventStart, currentDate) {
      const eventStartDate = new Date(eventStart);

      if (this.scale === 'month') {
        const daysInMonth = getDaysInMonth(currentDate);
        const dayOfEventInMonth = eventStartDate.getDate();
        const positionInMonthPx = (dayOfEventInMonth / daysInMonth) * this.baseWidth;
        return positionInMonthPx - 17;
      } else if (this.scale === 'week') {
        const startOfCurrentWeek = startOfWeek(currentDate, {weekStartsOn: 1});
        const daysInWeek = 7;
        const dayOfEventInWeek = differenceInDays(eventStartDate, startOfCurrentWeek) + 1;
        const positionInWeekPx = (dayOfEventInWeek / daysInWeek) * this.baseWidth;
        return positionInWeekPx - 17;
      } else if (this.scale === 'day') {
        return 3
      }
      return 0;
    },


    calculateStartPositionRange(eventStart, currentDate) {
      const eventStartDate = new Date(eventStart);

      if (this.scale === 'month') {
        const daysInMonth = getDaysInMonth(currentDate);
        const dayOfEventInMonth = eventStartDate.getDate();
        return (dayOfEventInMonth - 1) / (daysInMonth - 1) * 200 - (100 / daysInMonth);
      } else if (this.scale === 'week') {
        const startOfCurrentWeek = startOfWeek(currentDate, {weekStartsOn: 1});
        const dayOfEventInWeek = differenceInDays(eventStartDate, startOfCurrentWeek);
        if (dayOfEventInWeek <= 0) {
          return 0;
        }
        const daysInWeek = 7;
        return (dayOfEventInWeek / (daysInWeek - 1)) * 333 - (100 / daysInWeek);
      } else if (this.scale === 'day') {
        return 0
      }
      return 0;
    },

    calculateDuration(startDate, endDate) {
      const startDay = new Date(startDate);
      const endDay = new Date(endDate);


      if (startDay > endDay) {
        return 0;
      }

      if (this.scale === 'month') {
        return this.calculateMonthlyDuration(startDay, endDay);
      } else if (this.scale === 'week') {
        return this.calculateWeeklyDuration(startDay, endDay);
      } else if (this.scale === 'day') {
        return this.calculateDailyDuration(startDay, endDay);
      }
    },

    calculateDailyDuration(startDay, endDay) {
      const dayWidthPx = this.baseWidth;
      if (isSameDay(startDay, endDay)) {
        return dayWidthPx;
      }

      return (differenceInDays(endDay, startDay) + 1) * dayWidthPx;
    },

    calculateMonthlyDuration(startDay, endDay) {
      const monthWidthPx = this.baseWidth;
      let totalWidthPx = 0;
      let currentMonth = startOfMonth(startDay);

      while (currentMonth <= endDay) {
        const daysInCurrentMonth = getDaysInMonth(currentMonth);

        let daysInMonthInterval;
        if (isSameMonth(currentMonth, startDay) && !isSameMonth(startDay, endDay)) {
          daysInMonthInterval = differenceInDays(endOfMonth(currentMonth), startDay) + 1;
        } else if (isSameMonth(currentMonth, endDay) && !isSameMonth(startDay, endDay)) {
          daysInMonthInterval = endDay.getDate();
        } else if (isSameMonth(startDay, endDay)) {
          daysInMonthInterval = differenceInDays(endDay, startDay);
        } else {
          daysInMonthInterval = daysInCurrentMonth;

        }

        const monthProportion = daysInMonthInterval / daysInCurrentMonth;
        totalWidthPx += monthProportion * monthWidthPx;

        currentMonth = addMonths(currentMonth, 1);
      }

      return totalWidthPx;
    },

    calculateWeeklyDuration(startDay, endDay) {
      const weekWidthPx = this.baseWidth;
      let totalWidthPx = 0;
      let currentWeek = startOfWeek(startDay, {weekStartsOn: 1});

      while (currentWeek <= endDay) {
        const startOfCurrentWeek = currentWeek;
        const endOfCurrentWeek = endOfWeek(currentWeek, {weekStartsOn: 1});

        let daysInWeekInterval;
        if (isSameWeek(currentWeek, startDay, {weekStartsOn: 1})) {
          daysInWeekInterval = differenceInDays(endOfCurrentWeek, startDay);
        } else if (isSameWeek(currentWeek, endDay, {weekStartsOn: 1})) {
          daysInWeekInterval = differenceInDays(endDay, startOfCurrentWeek) + 1;
        } else {
          daysInWeekInterval = 7;
        }
        const weekProportion = daysInWeekInterval / 7;
        totalWidthPx += (weekProportion * weekWidthPx);

        currentWeek = addWeeks(currentWeek, 1);
      }

      return totalWidthPx;
    },


    calculateNestedStartPosition(mainEvent, nestedEventStart) {
      const mainEventStart = new Date(mainEvent.startEvent);
      const nestedStartDate = new Date(nestedEventStart);

      if (nestedStartDate <= mainEventStart && (mainEvent.event_type.value != "ACCORD_PRET_ACHETEUR" && mainEvent.event_type.value != "DEPOT_PC_DP_LOT" && mainEvent.event_type.value != "ACCORD_PC_DP_LOT") ) {
        return 0;
      }

      if (this.scale === 'month') {
        const daysInMonth = getDaysInMonth(mainEventStart);
        const daysFromStart = differenceInDays(nestedStartDate, mainEventStart);
        const monthProportion = daysFromStart / daysInMonth;
        const totalWidthPx = monthProportion * this.baseWidth;
        if(mainEvent.event_type.value == "ACCORD_PRET_ACHETEUR" || mainEvent.event_type.value == "DEPOT_PC_DP_LOT" || mainEvent.event_type.value == "ACCORD_PC_DP_LOT"){
          return this.calculateStartPositionDisk(mainEvent.startEvent, this.period) + (totalWidthPx - (this.baseWidth / 10)) + 16
        }
        return totalWidthPx - (this.baseWidth / 10);
      } else if (this.scale === 'week') {
        const startOfMainWeek = startOfWeek(mainEventStart, {weekStartsOn: 1});
        const daysFromStart = differenceInDays(nestedStartDate, startOfMainWeek);
        if (daysFromStart <= 0) {
          return 0;
        }
        const weekProportion = (daysFromStart - 1) / 7;
        const totalWidthPx = weekProportion * this.baseWidth;
        return totalWidthPx - (this.baseWidth / 10) - 23;
      } else if (this.scale === 'day') {
        const dayWidthPx = this.baseWidth;
        if (isSameDay(nestedStartDate, mainEventStart)) {
          return dayWidthPx;
        }

        return (differenceInDays(nestedStartDate, mainEventStart)) * dayWidthPx;
      }
      return 0;
    },


    updateTooltipPosition(mouseEvent, startEvent, endEvent) {
      const eventRect = mouseEvent.target.getBoundingClientRect();
      const mouseX = mouseEvent.clientX - eventRect.left;
      const mousePercentage = (mouseX / eventRect.width) * 100;
      this.tooltipStyle.left = endEvent ? mousePercentage + '%' : '50%';
    },

    showTooltip(eventId, mouseEvent, startEvent, endEvent, event, isNested = false) {
      this.hoveredEventId = eventId;
      this.updateTooltipPosition(mouseEvent, startEvent, endEvent);
      this.tooltipStyle.bottom = isNested ? '200%' : '140%';
      this.tooltipStyle["--color-event"] = isNested ? "#9E0430" : event.color;
    },
    hideTooltip() {
      this.hoveredEventId = null;
    },

    getContrastColor(hexColor) {
      if (hexColor.startsWith('rgb')) {
        hexColor = this.rgbToHex(hexColor);
      }
      hexColor = hexColor.replace('#', '');

      let r = parseInt(hexColor.substr(0, 2), 16);
      let g = parseInt(hexColor.substr(2, 2), 16);
      let b = parseInt(hexColor.substr(4, 2), 16);

      let luminance = (0.299 * r + 0.587 * g + 0.114 * b);

      return luminance > 186 ? 'black' : 'white';
    },
    rgbToHex(rgb) {
      let result = rgb.match(/\d+/g);
      if (!result || result.length < 3) {
        return '#000000';
      }
      let r = parseInt(result[0]).toString(16).padStart(2, '0');
      let g = parseInt(result[1]).toString(16).padStart(2, '0');
      let b = parseInt(result[2]).toString(16).padStart(2, '0');
      return `#${r}${g}${b}`;
    },
  }
}
</script>

<style scoped>
@import '../../assets/css/timeline.css';

.nested-date-disk {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 1px solid black;
  transform: translateY(80%);
  z-index: 1;
}


</style>



// WEBPACK FOOTER //
// src/views/operationPlanning/Evenement.vue